const SNIPPET2 = [
  {
    title: 'FireTruck complete restoration',
    data: 'Smarty shows us through a complete restoration of the rare Atari 2 player classic FireTruck!',
    readit: '',
    url: 'http://www.ukvac.com/forum/my-atari-fire-truck-24-02-14-resto-complete_topic333030.html',
    imgurl: 'http://2.bp.blogspot.com/-pWD2fGuGrLg/UwuyVqMnjBI/AAAAAAAAA-0/hh05fKZxGDE/s1600/SANY1001.JPG',
    objectID: 0
  }
];

export default SNIPPET2;


// WEBPACK FOOTER //
// ./src/data-forumsnippet2.js